/* Minimal JS: product gallery thumbs, quantity steppers, variant buttons, collection filters. No animation. */
document.addEventListener('click',function(e){
  var t=e.target.closest('[data-thumb]');
  if(t){var m=document.querySelector('[data-main-img]');if(m){var ts=t.getAttribute('data-thumb-set');if(ts){m.srcset=ts;}else{m.removeAttribute('srcset');}m.src=t.getAttribute('data-thumb');}
    document.querySelectorAll('[data-thumb]').forEach(function(b){b.classList.remove('on')});t.classList.add('on');}
  var q=e.target.closest('[data-qty]');
  if(q){var i=q.parentElement.querySelector('input');var v=parseInt(i.value||'1',10)+parseInt(q.getAttribute('data-qty'),10);i.value=Math.max(i.min===''?1:parseInt(i.min,10),v);}
});

/* Variant buttons → hidden variant id, price, availability, URL */
(function(){
  var form=document.querySelector('[data-product-form]');if(!form)return;
  var json=form.querySelector('[data-variants]');if(!json)return;
  var variants=JSON.parse(json.textContent),idInput=form.querySelector('[data-variant-id]');
  var current=variants.find(function(v){return String(v.id)===idInput.value})||variants[0];
  /* prices pre-formatted by Liquid's money filter (exact store format, 3-decimal TND included) */
  var pj=form.querySelector('[data-prices]'),prices=pj?JSON.parse(pj.textContent):{};
  function selected(){var opts=current.options.slice();
    form.querySelectorAll('fieldset[data-option-index]').forEach(function(fs){var c=fs.querySelector('input:checked');if(c)opts[+fs.dataset.optionIndex]=c.value;});return opts;}
  function refresh(){
    var opts=selected();
    form.querySelectorAll('fieldset[data-option-index]').forEach(function(fs){var idx=+fs.dataset.optionIndex;
      fs.querySelectorAll('input').forEach(function(inp){
        var ok=variants.some(function(v){return v.available&&v.options.every(function(o,i){return i===idx?o===inp.value:(i<idx?o===opts[i]:true)})});
        inp.disabled=!ok&&!inp.checked;var lb=inp.nextElementSibling;if(lb)lb.classList.toggle(lb.classList.contains('sw-c')?'oos':'off',!ok);});
      var nm=fs.querySelector('[data-selected-name]');if(nm)nm.textContent=opts[idx];});
    var v=variants.find(function(x){return x.options.every(function(o,i){return o===opts[i]})});
    var add=form.querySelector('[data-add]'),now=form.querySelector('[data-buy-now]'),lbl=form.querySelector('[data-add-label]');
    if(!v){add.disabled=true;if(now)now.disabled=true;return;}
    current=v;idInput.value=v.id;
    add.disabled=!v.available;if(now)now.disabled=!v.available;
    if(lbl)lbl.textContent=v.available?(lbl.dataset.add||(lbl.dataset.add=lbl.textContent)):(add.dataset.soldout||'نفذ');
    var p=document.querySelector('[data-price]');
    var pr=prices[v.id];
    if(p&&pr)p.innerHTML='<span class="ltr">'+pr[0]+'</span>'+(v.compare_at_price>v.price?' <s class="ltr">'+pr[1]+'</s>':'');
    if(v.featured_image){var m=document.querySelector('[data-main-img]');if(m){m.removeAttribute('srcset');m.src=v.featured_image.src;}}
    var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
  }
  var lbl=form.querySelector('[data-add-label]');if(lbl&&current.available)lbl.dataset.add=lbl.textContent;
  /* product with several colors opened on one of them (card dot → ?variant=): show that color's photo */
  if(/[?&]variant=/.test(location.search)&&form.querySelector('fieldset[data-option-index] .sws')&&current.featured_image){var m0=document.querySelector('[data-main-img]');if(m0){m0.removeAttribute('srcset');m0.src=current.featured_image.src;}}
  form.addEventListener('change',function(e){if(e.target.closest('fieldset[data-option-index]'))refresh();});
})();

/* "اشتري الآن": orders go through the cash-on-delivery app form, so scroll to it;
   without that form on the page, add to cart instead (the store's checkout takes no online payment) */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-buy-now]');if(!b||b.disabled)return;
  var sel=b.getAttribute('data-target'),t=null;
  try{t=sel?document.querySelector(sel):null;}catch(err){t=null;}
  if(t){t.scrollIntoView({behavior:'smooth',block:'start'});var i=t.querySelector('input[type=text],input[type=tel],input:not([type]),textarea');if(i)setTimeout(function(){i.focus({preventScroll:true});},500);return;}
  var f=b.closest('form'),add=f&&f.querySelector('[data-add]');if(add)add.click();
});

/* Collection filters: apply on change; empty price fields are left out of the URL */
document.addEventListener('change',function(e){
  var f=e.target.closest('[data-filters]');if(!f)return;
  if(e.target.type==='number'||!e.target.name)return;
  f.requestSubmit?f.requestSubmit():f.submit();
});
document.addEventListener('submit',function(e){
  var f=e.target.closest('[data-filters]');if(!f)return;
  f.querySelectorAll('input[type=number]').forEach(function(i){if(i.value==='')i.disabled=true;});
});

/* Product gallery: tap the main photo to zoom (full screen), swipe to change photo on touch screens */
(function(){
  var main=document.querySelector('[data-main-img]');if(!main)return;
  var thumbs=function(){return [].slice.call(document.querySelectorAll('[data-thumb]'));};
  var go=function(step){var t=thumbs();if(t.length<2)return;var i=t.findIndex(function(b){return b.classList.contains('on');});t[(i+step+t.length)%t.length].click();};
  main.style.cursor='zoom-in';
  main.addEventListener('click',function(){
    var o=document.createElement('div');o.className='zoom';o.setAttribute('role','dialog');o.setAttribute('aria-label','تكبير الصورة');
    o.innerHTML='<button type="button" class="zoom-x" aria-label="إغلاق">✕</button><img alt="">';
    o.querySelector('img').src=main.src.replace(/([?&])width=\d+/,'$1width=2000');
    var close=function(){o.remove();document.removeEventListener('keydown',key);};
    var key=function(e){if(e.key==='Escape')close();};
    o.addEventListener('click',close);document.addEventListener('keydown',key);document.body.appendChild(o);
  });
  var x0=null,y0=null;
  main.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY;},{passive:true});
  main.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;x0=null;
    if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){e.preventDefault();go(dx<0?1:-1);}});
})();

/* Card size choice: only one open at a time, closes on outside click */
document.addEventListener('click',function(e){
  document.querySelectorAll('details.qa[open]').forEach(function(d){if(!d.contains(e.target))d.removeAttribute('open');});
});

/* Instant search suggestions while typing. Shopify predictive search does not support Arabic (HTTP 417),
   so this uses the regular store search (prefix match) through the search.suggest template (JSON). */
(function(){
  var f=document.querySelector('[data-predictive]');if(!f)return;
  var input=f.querySelector('input[name=q]'),list=f.querySelector('.ps'),timer,last='';
  var close=function(){list.hidden=true;input.setAttribute('aria-expanded','false');};
  input.addEventListener('input',function(){
    clearTimeout(timer);var q=input.value.trim();
    if(q.length<2){close();return;}
    timer=setTimeout(function(){
      last=q;
      fetch(f.getAttribute('action')+'?view=suggest&type=product&q='+encodeURIComponent(q+'*'))
        .then(function(r){return r.json();}).then(function(ps){
          if(q!==last)return;
          var norm=function(x){return x.replace(/[ً-ْـ]/g,'').replace(/[أإآ]/g,'ا').replace(/ى/g,'ي').replace(/ة/g,'ه').toLowerCase();};
          var nq=norm(q),esc=function(x){return String(x).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');};
          ps=ps.filter(function(p){return norm(p.t).indexOf(nq)>=0;}).sort(function(x,y){return y.a-x.a;}).slice(0,6);
          list.innerHTML=ps.length?ps.map(function(p){return '<a role="option" href="'+esc(p.u)+'">'+(p.i?'<img src="'+esc(p.i)+'" alt="" width="48" height="64">':'')+'<span>'+esc(p.t)+'</span>'+(p.a?'':'<small>نفذ</small>')+'</a>';}).join(''):'<p class="ps-none">لا نتائج</p>';
          list.hidden=false;input.setAttribute('aria-expanded','true');
        }).catch(close);
    },250);
  });
  document.addEventListener('click',function(e){if(!f.contains(e.target))close();});
  input.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
})();

/* Card "add to cart" buttons (one variant, or the chosen size) → add, then open the cart */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-add-variant]');if(!b||b.disabled)return;
  b.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+b.getAttribute('data-add-variant'),quantity:1}]})})
    .then(function(r){if(!r.ok)throw r;location.href=b.getAttribute('data-cart')||'/cart';})
    .catch(function(){b.disabled=false;alert('تعذّرت الإضافة إلى السلة، حاول مرة أخرى.');});
});


/* Card color dots: tapping one switches the card to that color (photo, links, price, sizes) */
document.addEventListener('click',function(e){
  var d=e.target.closest('.mini-sw .dot[data-sib]');if(!d)return;
  var card=d.closest('.card'),s;try{s=JSON.parse(d.getAttribute('data-sib'));}catch(err){return;}
  card.querySelectorAll('.mini-sw .dot').forEach(function(x){x.classList.toggle('on',x===d);x.setAttribute('aria-pressed',x===d?'true':'false');});
  card.querySelectorAll('a.card-im, h3 a').forEach(function(a){a.setAttribute('href',s.u);});
  var img=card.querySelector('.card-im img');if(img&&s.i){img.removeAttribute('loading');if(s.s)img.srcset=s.s;img.src=s.i;}
  var pr=card.querySelector('.price span');if(pr)pr.textContent=s.p;var old=card.querySelector('.price s');if(old)old.remove();
  var im=card.querySelector('.card-im'),bd=im.querySelector('.badge:not(.badge-sale)');
  if(!s.a&&!bd){bd=document.createElement('span');bd.className='badge';bd.textContent='نفذ';im.appendChild(bd);}else if(s.a&&bd){bd.remove();}
  var act=card.lastElementChild,icon=(card.querySelector('.btn svg')||{}).outerHTML||'',cart=(card.querySelector('[data-cart]')||{dataset:{}}).dataset.cart||'/cart',esc=function(x){return String(x).replace(/&/g,'&amp;').replace(/</g,'&lt;');};
  var html;
  if(!s.a){html='<button class="btn" disabled>نفذ</button>';}
  else if(s.v.length===1){html='<button type="button" class="btn" data-add-variant="'+s.v[0].id+'" data-cart="'+cart+'">'+icon+' أضف إلى السلة</button>';}
  else{html='<details class="qa"><summary class="btn">'+icon+' أضف إلى السلة</summary><div class="qa-sz" role="group" aria-label="اختر المقاس">'+s.v.map(function(v){return '<button type="button" class="sz'+(v.a?'':' off')+'" data-add-variant="'+v.id+'" data-cart="'+cart+'"'+(v.a?'':' disabled')+'><span class="ltr">'+esc(v.l)+'</span></button>';}).join('')+'</div></details>';}
  var w=document.createElement('div');w.innerHTML=html;act.replaceWith(w.firstChild);
});

/* Cash-on-delivery app (EasySell) loads the full-size original photo (~1 MB) for its 50 px thumbnail → ask the CDN for 160 px */
(function(){
  var fix=function(root){(root.querySelectorAll?root:document).querySelectorAll('img.es-image').forEach(function(i){
    var s=i.getAttribute('src')||'';if(/cdn\.shopify\.com|\/cdn\/shop\//.test(s)&&!/[?&]width=/.test(s)){i.setAttribute('src',s+(s.indexOf('?')<0?'?':'&')+'width=160');}});};
  new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1)fix(n.parentNode||n);});});}).observe(document.documentElement,{childList:true,subtree:true});
  fix(document);
})();

/* Product color circles (each color = its own product page):
   photos of the other colors are downloaded in advance, and a tap shows the new photo at once while the page loads */
(function(){
  var links=[].slice.call(document.querySelectorAll('.sws a.sw-c[data-srcset]'));if(!links.length)return;
  var main=document.querySelector('[data-main-img]'),sizes=main?main.getAttribute('sizes'):'';
  var warm=function(){links.forEach(function(a){if(a.classList.contains('on'))return;var i=new Image();i.sizes=sizes;i.srcset=a.dataset.srcset;i.src=a.dataset.img;});};
  /* start as soon as the main photo is shown, so the other colors are ready before the customer taps */
  var go=function(){if('requestIdleCallback' in window)requestIdleCallback(warm,{timeout:600});else setTimeout(warm,300);};
  if(!main||main.complete)go();else{main.addEventListener('load',go,{once:true});main.addEventListener('error',go,{once:true});}
  links.forEach(function(a){a.addEventListener('click',function(e){
    if(e.metaKey||e.ctrlKey||e.shiftKey||a.classList.contains('on'))return;
    links.forEach(function(x){x.classList.toggle('on',x===a);});
    if(main&&a.dataset.img){main.srcset=a.dataset.srcset;main.src=a.dataset.img;}
    var lb=a.closest('.opt')&&a.closest('.opt').querySelector('.lbl b');if(lb)lb.textContent=a.getAttribute('aria-label');
  });});
})();

/* Silent photo warm-up. Shopify's CDN builds each photo size the first time it is asked for (~1 s),
   then serves it in ~0.3 s to everyone. When a product page is opened, this asks the CDN to prepare
   every size the theme uses for every color of the model (HEAD requests: nothing is downloaded),
   for Chrome/Android and Safari/iPhone. A color that is already prepared is skipped after one check. */
(function(){
  var lists=[].slice.call(document.querySelectorAll('script[data-warm]'));if(!lists.length||!window.fetch)return;
  var seen={},models=[];
  lists.forEach(function(el){try{JSON.parse(el.textContent).forEach(function(imgs){var k=imgs[0];if(k&&!seen[k]){seen[k]=1;models.push(imgs);}});}catch(e){}});
  var FIRST=[160,200,300,450,600,800,1000],REST=[200,600,800,1000];
  var ACCEPT=['image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8','image/webp,image/avif,image/jxl,image/heic,image/heic-sequence,video/*;q=0.8,image/png,image/svg+xml,image/*;q=0.8,*/*;q=0.5'];
  var url=function(base,w){return base.replace(/([?&])width=\d+/,'$1width='+w);};
  var head=function(u,a){return fetch(u,{method:'HEAD',headers:{Accept:a},priority:'low',credentials:'omit'}).then(function(r){return r.headers.get('cf-cache-status');}).catch(function(){return 'HIT';});};
  var queue=[];
  var warmColor=function(imgs){
    /* one check: if the card photo of this color is already prepared, the rest of it is too */
    return head(url(imgs[0],450),ACCEPT[1]).then(function(st){
      if(st==='HIT')return;
      imgs.forEach(function(b,i){(i?REST:FIRST).forEach(function(w){ACCEPT.forEach(function(a){queue.push([url(b,w),a]);});});});
    });
  };
  var run=function(){
    var n=0,next=function(){var j=queue.shift();if(!j)return;n++;head(j[0],j[1]).then(function(){n--;next();});};
    Promise.all(models.map(warmColor)).then(function(){for(var k=0;k<3;k++)next();});
  };
  var start=function(){setTimeout(function(){if('requestIdleCallback' in window)requestIdleCallback(run,{timeout:3000});else run();},1500);};
  if(document.readyState==='complete')start();else window.addEventListener('load',start,{once:true});
})();

/* Home «تصفّح المزيد»: open / close the extra models in place (the link stays a normal link without JS) */
(function(){
  function warm(b){var box=document.getElementById(b.getAttribute('aria-controls'));if(box)box.querySelectorAll('img[loading="lazy"]').forEach(function(i){i.loading='eager'})}
  ['pointerenter','touchstart','focusin'].forEach(function(ev){document.addEventListener(ev,function(e){var b=e.target.closest&&e.target.closest('[data-fp-toggle]');if(b)warm(b)},{capture:true,passive:true})});
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-fp-toggle]');if(!b)return;
    var box=document.getElementById(b.getAttribute('aria-controls'));if(!box)return;
    e.preventDefault();warm(b);
    var sec=b.closest('.sec'),lbl=b.querySelector('[data-fp-label]');
    if(!b.dataset.more)b.dataset.more=lbl.textContent;
    var open=b.getAttribute('aria-expanded')!=='true';
    clearTimeout(box._t);cancelAnimationFrame(box._raf);
    if(open){
      box.hidden=false;sec.classList.add('fp-on');
      box.style.maxHeight='0px';void box.offsetHeight;
      box.classList.add('open');box.style.maxHeight=box.scrollHeight+'px';
      box._t=setTimeout(function(){box.style.maxHeight='none'},950);
    }else{
      /* while the cards fold up, keep the button where the visitor's finger is */
      var y0=b.getBoundingClientRect().top,t0=performance.now();
      box.style.maxHeight=box.scrollHeight+'px';void box.offsetHeight;
      box.classList.remove('open');box.style.maxHeight='0px';
      (function keep(){window.scrollBy({top:b.getBoundingClientRect().top-y0,behavior:'instant'});if(performance.now()-t0<1000)box._raf=requestAnimationFrame(keep);else{box.hidden=true;sec.classList.remove('fp-on');window.scrollBy({top:b.getBoundingClientRect().top-y0,behavior:'instant'})}})();
    }
    b.setAttribute('aria-expanded',open?'true':'false');lbl.textContent=open?(b.dataset.less||'عرض أقل'):b.dataset.more;
  });
})();

/* Home: show the header's gold line only after the first photo (hero) has been scrolled past */
(function(){
  if(!document.body.classList.contains('template-index'))return;
  var hdr=document.querySelector('.hdr'),hero=document.querySelector('.hero');if(!hdr)return;
  if(!hero){hdr.classList.add('hdr-line');return}
  var tick=false;
  function upd(){tick=false;hdr.classList.toggle('hdr-line',hero.getBoundingClientRect().bottom<=hdr.getBoundingClientRect().bottom+2)}
  window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(upd)}},{passive:true});
  window.addEventListener('resize',upd);upd();
})();
